import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import CancelIcon from '@material-ui/icons/DeleteForever';
import ReservationAPI from '../../../../API/ReservationAPI';
import CarOrderReservationsTableHeader from './CarOrderReservationsTableHeader';
import CarOrderReservationsToolbar from './CarOrderReservationsToolbar';
import ReservationsExtendCancelModal from '../../../Reservations/Personal/ReservationsExtendCancelModal';
import LinearProgress from '../../../Utils/LinearProgress';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { handleServerError } from '../../../../Utils/Helper';
import { FormatDate, FormatDateTime } from '../../../Utils/GenericFunctions';
import { NO_TABLE_DATA_MESSAGE, STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_ASCENDING, ORDER_BY_EXPIRATION_DATE } from '../../../../Utils/Constants';


const styles = theme => ({
  root: {
    width: '100%',
    backgroundColor: '#F6F6F6'
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  textCenter: {
    textAlign: 'center'
  },
  tblRow: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
    },
    height: '30px'
  },
  cellPadding: {
    paddingLeft: '6px'
  },
  buttons: {
    float: 'right',
    display: 'flex'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  iconsWidth: {
    width: '38px'
  },
  checboxSize: {
    height: '30px',
    width: '44px'
  },
  onHoldColor: {
    color: '#db4437'
  },
  tblFooter: {
    height: '30px',
    minHeight: '30px'
  },
  pageButton: {
    width: '30px',
    height: '30px',
    margin: '0px 8px'
  }
});


export class CarOrderReservationsTable extends Component {
  searchTimer = null;
  dataAPI;

  constructor(props) {
    super(props);
    this.state = {
      order: ORDER_ASCENDING,
      orderBy: ORDER_BY_EXPIRATION_DATE,
      data: [],
      page: STARTING_TABLE_PAGE,
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      count: 0,
      search: '',
      reloading: false,
      openModal: false,
      openReasons: '',
      openReasonsTitle: '',
      carReservationId: 0,
      openError: false,
      alertMessage: '',
    };
    this.dataAPI = new ReservationAPI();
  }

  componentDidMount() {
    this.reloadTable('sameCharacteristics');
  };

  componentWillReceiveProps(props) {
    if (props.reservationFilterValue !== this.props.reservationFilterValue) {
      this.reloadTable(props.reservationFilterValue);
    }
    else {
      return null;
    }
  }

  reloadTable(filter) {
    this.setState({ reloading: true });
    var tableData = {};
    if (filter === 'allReservations') {
      tableData = this.dataAPI.getReservationsBySimilarity(this.props.carDetail.Id, STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search);
    }
    else {
      tableData = this.dataAPI.getReservationsByHash(this.props.carDetail.FeaturesHash, STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search);
    }
    tableData.then((response) => {
      this.setState({
        data: response.data.ListReservedCars,
        count: response.data.NumberFilteredResults,
        page: STARTING_TABLE_PAGE,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ reloading: true });
    var tableData = {};
    if (this.props.reservationFilterValue === 'allReservations') {
      tableData = this.dataAPI.getReservationsBySimilarity(this.props.carDetail.Id, this.state.page, this.state.rowsPerPage, orderBy, order, this.state.search);
    }
    else {
      tableData = this.dataAPI.getReservationsByHash(this.props.carDetail.FeaturesHash, this.state.page, this.state.rowsPerPage, orderBy, order, this.state.search);
    }
    tableData.then((response) => {
      this.setState({
        data: response.data.ListReservedCars,
        count: response.data.NumberFilteredResults,
        order, orderBy,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ reloading: true });
    var tableData = {};
    if (this.props.reservationFilterValue === 'allReservations') {
      tableData = this.dataAPI.getReservationsBySimilarity(this.props.carDetail.Id, page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search);
    }
    else {
      tableData = this.dataAPI.getReservationsByHash(this.props.carDetail.FeaturesHash, page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search);
    }
    tableData.then((response) => {
      this.setState({
        data: response.data.ListReservedCars,
        count: response.data.NumberFilteredResults,
        page: page,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ reloading: true });
    var tableData = {};
    if (this.props.reservationFilterValue === 'allReservations') {
      tableData = this.dataAPI.getReservationsBySimilarity(this.props.carDetail.Id, this.state.page, event.target.value, this.state.orderBy, this.state.order, this.state.search);
    }
    else {
      tableData = this.dataAPI.getReservationsByHash(this.props.carDetail.FeaturesHash, this.state.page, event.target.value, this.state.orderBy, this.state.order, this.state.search);
    }
    tableData.then((response) => {
      this.setState({
        data: response.data.ListReservedCars,
        count: response.data.NumberFilteredResults,
        rowsPerPage: event.target.value,
        reloading: false
      });
    }).catch((error) => {
      this.setState({
        reloading: false,
        openError: true,
        alertMessage: handleServerError(error)
      })
    });
  };

  reloadTableBySearch(searchBy) {
    this.setState({ reloading: true });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      var tableData = {};
      if (this.props.reservationFilterValue === 'allReservations') {
        tableData = this.dataAPI.getReservationsBySimilarity(this.props.carDetail.Id, STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, searchBy);
      }
      else {
        tableData = this.dataAPI.getReservationsByHash(this.props.carDetail.FeaturesHash, STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, searchBy);
      }
      tableData.then((response) => {
        this.setState({
          data: response.data.ListReservedCars,
          count: response.data.NumberFilteredResults,
          search: searchBy,
          page: STARTING_TABLE_PAGE,
          reloading: false
        });
      }).catch((error) => {
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      });
    }, 1500);
  };

  handleClose = () => {
    this.setState({
      openModal: false,
      carReservationId: 0,
      openReasons: '',
      openReasonsTitle: ''
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleClick = (id, customer) => {
    const { carReservationId } = this.state;
    let newCarReservationId = 0;
    let newCustomer = '';

    if (carReservationId === id) {
      newCarReservationId = 0;
      newCustomer = '';
    } else {
      newCarReservationId = id;
      newCustomer = customer
    }

    this.setState({ carReservationId: newCarReservationId });
    this.handleCheckReservation(newCarReservationId, newCustomer);
  };

  handleCheckReservation = (id, customer) => {
    this.props.handleCheckReservation(id, customer);
  }

  isSelected = id => this.state.carReservationId === id;

  handleClickCancel = (reservationId) => {
    this.setState({
      openModal: true,
      carReservationId: reservationId,
      openReasons: 'Cancellation',
      openReasonsTitle: 'SELECIONAR MOTIVO DE CANCELAMENTO DE RESERVA'
    });
  };

  detectCancellation = () => {
    this.handleClose();
  };

  renderTableRecords(cReservationList) {
    const { classes } = this.props;

    return cReservationList.map(rItem => {
      const isSelected = this.isSelected(rItem.reservationId);
      const rExpDate = rItem.reservedCarExpirationDate;
      return (
        <TableRow key={rItem.reservationId} tabIndex={-1} className={classes.tblRow}>
          <TableCell className={classNames(classes.tblBorder, classes.iconsWidth)} component='th' scope='row' padding='none'>
            <Checkbox disabled={rExpDate === null || !this.props.carDetail.Reservation} className={classes.checboxSize} checked={isSelected} onClick={() => this.handleClick(rItem.reservationId, rItem.reservedCarClient)} />
          </TableCell>
          {this.props.reservationFilterValue === 'allReservations' ?
            <React.Fragment>
              <TableCell key={'0'} className={classNames(classes.tblBorder, classes.cellPadding, rExpDate !== null ? null : classes.onHoldColor)} component='th' scope='row' padding='none'>
                {rItem.reservedCarAnnouncedOptionalsDescription}
              </TableCell>
              <TableCell key={'1'} className={classNames(classes.tblBorder, classes.textCenter, rExpDate !== null ? null : classes.onHoldColor)} component='th' scope='row' padding='none'>
                {rItem.reservedCarColorDesc}
              </TableCell>
              <TableCell key={'2'} className={classNames(classes.tblBorder, classes.textCenter, rExpDate !== null ? null : classes.onHoldColor)} component='th' scope='row' padding='none'>
                {rItem.reservedSalesChannel}
              </TableCell>
            </React.Fragment>
            : null
          }
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, rExpDate !== null ? null : classes.onHoldColor)} component='th' scope='row' padding='none'>
            {rExpDate !== null ? FormatDate(rItem.reservedCarDate) : FormatDateTime(rItem.reservedCarDate)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, rExpDate !== null ? null : classes.onHoldColor)} component='th' scope='row' padding='none'>
            {rExpDate !== null ? FormatDate(rExpDate) : null}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding, rExpDate !== null ? null : classes.onHoldColor)} component='th' scope='row' padding='none'>
            {rItem.reservedCarHolderName}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding, rExpDate !== null ? null : classes.onHoldColor)} component='th' scope='row'>
            {rItem.reservedCarClient}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.iconsWidth)} padding='none'>
            <Tooltip title='Cancelar Reserva' placement='bottom' >
              <IconButton aria-label='Cancel' onClick={() => { this.handleClickCancel(rItem.reservationId) }} className={classNames(classes.buttonSizeTbl, rExpDate !== null ? null : classes.onHoldColor)} >
                <CancelIcon />
              </IconButton>
            </Tooltip>
          </TableCell>
        </TableRow>
      );
    })
  }

  renderNoRecordMessages() {
    return NO_TABLE_DATA_MESSAGE;
  }


  render() {
    const { classes } = this.props;
    const { data, order, orderBy, rowsPerPage, page, count, reloading } = this.state;

    return (
      <Paper className={classes.root}>

        <CarOrderReservationsToolbar
          reloadTableBySearch={this.reloadTableBySearch.bind(this)}
          reloadTable={this.reloadTable.bind(this)}
        />
        <div className={classes.tableWrapper}>
          <Table>
            <TableHead className={classes.tblHead} >
              <CarOrderReservationsTableHeader
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
                reservationFilterValue={this.props.reservationFilterValue}
              />
            </TableHead>
            <TableBody>
              {this.renderTableRecords(data)}
            </TableBody>
          </Table>
          {(!data.length) ? this.renderNoRecordMessages() : null}
        </div>
        {reloading && <LinearProgress />}
        <TablePagination
          component='div'
          count={count}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          labelRowsPerPage={'Resultados por página:'}
          page={page}
          backIconButtonProps={{ className: classes.pageButton }}
          nextIconButtonProps={{ className: classes.pageButton }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => `A mostrar resultados ${from}-${to} de ${count}`}
          classes={{ toolbar: classes.tblFooter }}
        />

        <ReservationsExtendCancelModal
          openConfirmationModal={this.state.openModal}
          handleClose={this.handleClose.bind(this)}
          openReasons={this.state.openReasons}
          openReasonsTitle={this.state.openReasonsTitle}
          carReservationId={this.state.carReservationId}
          reloadTable={this.reloadTable.bind(this)}
          detectCancellation={this.detectCancellation.bind(this)}
        />

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    );
  }
}

CarOrderReservationsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTableBySearch: PropTypes.func,
  reloadTable: PropTypes.func
};

export default withStyles(styles)(CarOrderReservationsTable);


// WEBPACK FOOTER //
// ./src/components/FirmPurchases/CarsList/CarOrdering/CarOrderReservationsTable.js